module.exports = __webpack_public_path__ + "media/images/cliparts/Comming soon 4-12076edca120101ab2ce11a2a1da79c8.svg";